import { gql } from 'graphql-request'

const GET_FILTERS = gql`
  query getFilters($for_creators: Boolean!, $type: String) {
    product_categories(
      where: {
        _and: {
          products: {
            product: { status: { _eq: "active" }, type: { _eq: $type } }
          }
        }
      }
    ) @skip(if: $for_creators) {
      id
      name
    }
    creator_categories(
      where: {
        _and: {
          creators: {
            account_status: { _eq: "active" }
            products: { status: { _eq: "active" }, type: { _eq: $type } }
          }
        }
      }
    ) {
      id
      name
    }
  }
`
export default GET_FILTERS
